import React, { useState, useEffect } from 'react';
import { TextField, Button, CircularProgress } from "@mui/material";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import CheckIcon from "@mui/icons-material/Check";
import SaveIcon from "@mui/icons-material/Save";
import { setDoc, doc, getDoc } from "firebase/firestore";
import { db } from "../lib/firebaseConfig";
import { useAuth } from '../hooks/auth';

function DataSettingsCompo() {
  const [gaCode, setGaCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    const fetchGaCode = async () => {
      if (user) {
        const analyticsDoc = doc(db, `users/${user.uid}/analytics/gaCode`);
        const analyticsData = await getDoc(analyticsDoc);
        if (analyticsData.exists()) {
          setGaCode(analyticsData.data().gaCode);
        }
      }
    };
    fetchGaCode();
  }, [user]);

  useEffect(() => {
    if (success) {
      setLoading(false); // Réinitialiser l'état du bouton à false
    }
  }, [success]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError(null);

    const analyticsDoc = doc(db, `users/${user.uid}/analytics/gaCode`);
    
    try {
      await setDoc(analyticsDoc, { gaCode: gaCode }, { merge: true });
      console.log("GA Code has been updated in Firestore.");
      setSuccess(true);
    } catch (error) {
      console.error("Erreur lors de la mise à jour du code GA dans Firestore: ", error);
      setSuccess(false);
      setError("Erreur lors de la mise à jour du code GA dans Firestore.");
    }
  };

  return (
    <div className="SettingsPanel" style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>

      <>
      <h1 style={{fontSize: '50px', fontWeight: 'bold', margin: '50px', marginBottom: '0px'}}>Analytics</h1>
      <p style={{marginBottom: '50px'}}>Development in progress ⚙️</p>
      </>
      <form className="setting-col-1" onSubmit={handleSubmit}>
        <TextField
          label="Google Analytics Tracking Code"
          variant="outlined"
          className="setting_input"
          type="text"
          value={gaCode}
          onChange={(e) => setGaCode(e.target.value)}
          InputProps={{ style: { color: "white", background: 'transparent' }}}
          InputLabelProps={{ style: { color: "rgb(255 255 255 / 60%)" }}}

          id="outlined-basic"
          color="secondary"
        />
        <br />
        <Button
          variant="contained"
          type="submit"
          style={{
            color: "white",
            fontWeight: "bold",
            borderRadius: "5px",
            padding: "10px",
            cursor: "pointer",
            position: "relative",
            marginBottom: '10px'
          }}
          startIcon={loading ? <CircularProgress size="1rem" /> : success ? <CheckIcon /> : <SaveIcon />}
        >
          {loading ? 'Saving...' : success ? 'Saved' : 'Save'}
        </Button>
        {success && 
          <Alert severity="success">
            <AlertTitle>Success</AlertTitle>
            Le code Google Analytics a été enregistré avec succès !
          </Alert>
        }
        {error && 
          <Alert severity="error">
            <AlertTitle>Error</AlertTitle>
            {error}
          </Alert>
        }
      </form>
    </div>
  );
}

export default DataSettingsCompo;
